let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5cN1A")).then(() => parcelRequire('9UkW6'));